import React from "react";
import { EyeIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/content";
export function HeroSection() {
  return <header className="w-full bg-cream px-5 pb-14 pt-8 sm:pt-12" data-id="element-163" data-mp="219bbtkd4hzav">
      <div className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-164" data-mp="1x914o4dlh2uf">
        <div className="flex flex-wrap items-center justify-center gap-2.5" data-id="element-165" data-mp="1xb3r6efjgdue">
          <span className="flex items-center gap-2" data-id="element-166" data-mp="1sazc8sua3r6a">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-navy-900" data-id="element-167" data-mp="1nig102j2d84n">
              <EyeIcon className="h-5 w-5 text-gold-400" aria-hidden="true" data-id="element-168" data-mp="1ijbq97ghr2c7" />
            </span>
            <span className="font-serif text-lg font-bold text-navy-900" data-id="element-169" data-mp="1dla6slf5l107">Clinical Pathway™</span>
          </span>
          <span className="rounded-full border border-gold-400 bg-gold-100 px-3 py-1 text-xs font-bold uppercase tracking-wide text-navy-800" data-id="element-170" data-mp="19jga0o82wh5b">
            By Dr. Daniel Reynolds
          </span>
        </div>

        <p className="mt-7 text-sm font-bold uppercase tracking-[0.16em] text-gold-600" data-id="element-171" data-mp="31n30j27mvnej">The Blepharoplasty Clinical Pathway™</p>
        <h1 className="mt-3 font-serif text-[38px] font-extrabold leading-[1.08] text-ink sm:text-6xl lg:text-[68px]" data-id="element-172" data-mp="36g5n2qdztwl8">
          Analyze any educational blepharoplasty case in{" "}
          <em className="whitespace-nowrap text-gold-600" data-id="element-173" data-mp="2wpufmtv3p59l">15 minutes</em>
        </h1>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-muted sm:text-xl" data-id="element-174" data-mp="3kfovzlempbyl">
          A structured clinical case-review pathway to organize your observations, identify the variables that deserve attention,
          recognize information gaps and build a <strong className="text-ink" data-id="element-175" data-mp="3gd0j92msnkwc">consistent approach</strong> to educational case analysis.
        </p>

        <img src={images.mainMockup} alt="Blepharoplasty Clinical Pathway: 6 volumes, 5 bonuses and case review tools" className="mt-8 w-full max-w-2xl" data-id="element-176" data-mp="1zz1zxxc2xf8c" />

        <p className="mt-2 rounded-xl bg-navy-900 px-4 py-2.5 text-[15px] font-bold text-white sm:text-base" data-id="element-177" data-mp="ahn7le3ntrgb">
          6 Premium Volumes <span className="text-gold-400" data-id="element-178" data-mp="5iack62mxe2n">+</span> 5 Professional Bonuses <span className="text-gold-400" data-id="element-179" data-mp="rtyqkuwjqfr">+</span> 30+ Tools
        </p>

        <div className="mt-8 w-full max-w-xl" data-id="element-180" data-mp="q0rb3cgt26p">
          <CTAButton id="first-cta" label="I want the Clinical Pathway™" data-id="element-181" data-mp="3sw5xexbtnf20" />
          <p className="mt-4 text-[15px] leading-relaxed text-muted" data-id="element-182" data-mp="3sttful9z76ph">
            Instant digital access · One-time payment of <strong className="text-ink" data-id="element-183" data-mp="3ixq3ynpbntpc">$27</strong> · Lifetime access · 7-day guarantee
          </p>
        </div>

        <div className="mt-8" data-id="element-184" data-mp="3dxlo8zw8n306">
          <Countdown data-id="element-185" data-mp="3dyvnhsetuh8e" />
        </div>
      </div>
    </header>;
}